import { render, staticRenderFns } from "./PromotionExclusive.vue?vue&type=template&id=5d269476&"
import script from "./PromotionExclusive.vue?vue&type=script&lang=ts&"
export * from "./PromotionExclusive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports